// A 403 can carry a JSON body or the api's text/plain "Forbidden"; the JSON
// response handler reports the latter as a PARSING_ERROR carrying the real status.
export const statusOf = (error: unknown): unknown => {
  const { status, originalStatus } =
    (error as { status?: unknown; originalStatus?: unknown } | undefined) ?? {};

  return status === 'PARSING_ERROR' ? originalStatus : status;
};

/** The two answers that mean "not yours to see". A server failure is neither, and saying
 * so would tell the reader they lack access to something that may well be theirs. */
export const isRefusalOrMissing = (error: unknown): boolean =>
  statusOf(error) === 403 || statusOf(error) === 404;
